
import Vue from "vue";
import store from "@/store";
import { APPLICATION } from "@/store/applications";
import { createNamespacedHelpers } from "vuex";
import { CARD_TYPES } from "@/constants/cards";
import { ICardDetails, ICard } from "@/store/applications/types";
import { Products } from "@/api/signup/types/CardModel";

const { mapGetters, mapState } = createNamespacedHelpers(
  APPLICATION.NAME_SPACE
);


export default Vue.extend({
  data() {
    return {
      activeIndex: 0
    };
  },
  computed: {
    activeCard(): any {
      return this.cards && this.cards[this.activeIndex];
    },
    cards() {
      const cardDetails: ICardDetails =
        store.getters[APPLICATION.NS(APPLICATION.GETTERS.GET_CARD_DETAILS)];

      return cardDetails && cardDetails.cards;
    },
    cardType: {
      get(): string {
        return this.activeCard && this.activeCard.cardType;
      }
    },
    cardOffer() {
      return this.cardType === CARD_TYPES.VEHICLE
        ? "Vehicle Card"
        : "Driver Card";
    },
    drivername() {
      if (
        this.cardType === CARD_TYPES.DRIVER ||
        this.cardType === CARD_TYPES.DRIVER_VEHICLE
      ) {
        return (
          this.activeCard &&
          this.activeCard.driver &&
          this.activeCard.driver.name
        );
      } else if (this.cardType === CARD_TYPES.ANY) {
        return "Any driver";
      } else {
        return "";
      }
    },
    deliveryMethod() {
      const promoCodeDeliveryMethod =
        store.state.promoOffer.promoCode &&
        store.state.promoOffer.promoCode.deliveryMethod;

      const standardOfferDeliveryMethod =
        store.state.standardOffer.offer &&
        store.state.standardOffer.offer.deliveryMethod;

      return promoCodeDeliveryMethod || standardOfferDeliveryMethod;
    },
    phoneNumber() {
      return (
        store.state.application.applicationData &&
        store.state.application.applicationData.finalDetails &&
        store.state.application.applicationData.finalDetails.contactNumber
      );
    },
    showVehicle() {
      if (this.cards) {
        return (
          this.cardType === CARD_TYPES.DRIVER_VEHICLE ||
          this.cardType === CARD_TYPES.VEHICLE
        );
      }
      return false;
    },
    vehicleRegistration() {
      return (
        this.activeCard &&
        this.activeCard.vehicle &&
        this.activeCard.vehicle.registration
      );
    },
    ...mapState({
      applicantFullName: () =>
        store.state.application.applicationData &&
        store.state.application.applicationData.fullName,
      tradingName: () =>
        (store.state.application.applicationData &&
          store.state.application.applicationData.businessDetails &&
          store.state.application.applicationData.businessDetails
            .tradingName) ||
        (store.state.application.applicationData &&
          store.state.application.applicationData.businessDetails &&
          store.state.application.applicationData.businessDetails.businessName)
    })
  },
  methods: {
    cardSelectChange(event: any) {
      this.activeIndex = event.target.value;
    }
  }
});
